import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import { Form } from "@formio/react";
import { Formio } from "formiojs";
import { useHistory } from "react-router-dom";
import store from "../../store"
import ACTIONS from '../../actions/types'

// GLOBAL
import GLOBALS from "../../globals/index";

// functions
import AJAX from "../../functions/ajax";

GLOBALS.blockOnChangeOnFormRender = true;

//https://docs.form.io/developers/form-renderer
const FormioForm = ({
  formData,
  options,
  hideErrorMsgs,
  onChange,
  onSave,
  blockFormSubmission,
}) => {
  const _id = Math.random();
  let formioForm = null;

  let starRenderTimeout1;
  let starRenderTimeout2;

  // OPTIONS SETUP
  const copyOptionsWithDefaults = options => ({
    saveDraft: false,
    noAlerts: true,
    baseUrl: "/",
    highlightErrors: false,
    readOnly: blockFormSubmission || false,
    ...options,
  });

  // ON RENDER
  useEffect(() => {
    GLOBALS.blockOnChangeOnFormRender = true;
    init();
  }, []);

  const init = () => {
    Formio.createForm(
      document.getElementById(_id),
      formData.schema,
      copyOptionsWithDefaults(options)
    ).then(form => {
      form.submission = {
        data: formData.content,
      };

      formioForm = form;

      form.on("change", changed => {
        onFormChange(changed);
      });

      addStarRating();
    });
  };

  // ON UNMOUNT
  useEffect(() => {
    return () => {
      if(formioForm) formioForm.destroy();
    };
  }, []);

  const enableOnChangeEvent = () => {
    GLOBALS.blockOnChangeOnFormRender = false;
  };

  const onFormChange = formInfo => {
    if (GLOBALS.blockOnChangeOnFormRender) return false;

    if (formInfo.changed) {
      if (onChange) onChange();
      //auto save on form change
      if (formData.auto_save) {
        AJAX()
          .send(_id, formData.save_api.api.method, formData.save_api.api.url, {
            data: formInfo.data,
          })
          .then(res => {
            if(!res) store.dispatch({ type: ACTIONS.ERROR_POPUP });
            if (onSave) onSave(res);
          })
      }
    }
  };

  const addStarOnEnter = (target) => {
    console.log('target', target)
    //target.parentNode.querySelector('input').click();
  }

  const addStars = () => {
    const starRatins = document.querySelectorAll(".star-rating");

    starRatins.forEach(starRating => {
      const inputGroup = starRating.querySelectorAll(".form-radio label");
      let checked = false;

      // iterate backwords trough star set
      for (var i = inputGroup.length - 1; i >= 0; i--) {
        const input = inputGroup[i].getElementsByTagName("input")[0];
        const label = inputGroup[i].getElementsByTagName("span")[0];

        // if iterated input is checked
        if (input.checked) {
          checked = true;
        }

        // make label focusable
        label.tabIndex = '0'

        // if last input checked, clear stars
        if (inputGroup[inputGroup.length - 1].querySelector("input").checked) {
          label.classList.remove("add_star_full");
        } else if (checked && i !== inputGroup.length - 1) {
          label.classList.remove("add_star_line");
          label.classList.add("add_star_full");
        } else {
          label.classList.add("add_star_line");
          label.classList.remove("add_star_full");
        }
      }
    });
  };

  const addStarRating = onWhat => {
    const allLabels = document.querySelectorAll(".star-rating label");
    const allStars = document.querySelectorAll(".star-rating label > input");

    if (allStars.length !== 0) {
      starRenderTimeout1 = setTimeout(() => {
        addStars();
      }, 0);

      allStars.forEach(star => {
        star.addEventListener("click", function (e) {
          starRenderTimeout2 = setTimeout(() => {
            addStars();
          }, 0);
        });
      });

      allLabels.forEach(label => {
        label.addEventListener("keypress", function (e) {
          label.click();
        });
      });
    }
  };

  // on unmount
  useEffect(() => {
    return () => {
      clearTimeout(starRenderTimeout1);
      clearTimeout(starRenderTimeout2);
      GLOBALS.blockOnChangeOnFormRender = true;
    };
  }, []);

  return (
    <div id="formioo-form" className="formioForm" onMouseDown={enableOnChangeEvent}>
      <div
        className={`formio-root ${hideErrorMsgs ? "hide-error-messages" : ""} ${
          blockFormSubmission ? "formioo-form-blocked" : ""
        }`}
      >
        <div id={_id}></div>
      </div>
    </div>
  );
};

export default FormioForm;
